import classnames from 'classnames/bind'
import Pagination from 'entities/pagination'
import PropTypes from 'prop-types'
import React from 'react'
import { MdCheck } from 'react-icons/md'
import styles from './button_for_all_select.module.scss'

const cx = classnames.bind(styles)
const ButtonForAllSelect = ({ className, disabled, isAllSelected, pagination, target, onChecked }) => (
  <button
    type="button"
    className={cx(className, styles.button, {
      buttonActive: isAllSelected
    })}
    disabled={disabled}
    onClick={onChecked}
  >
    <div
      className={cx(styles.outline, {
        outlineActive: isAllSelected
      })}
    >
      <MdCheck size={20} />
    </div>
    <span
      className={cx(styles.text, {
        textActive: isAllSelected
      })}
    >
      {pagination && pagination.totalPages > 1
        ? I18n.t('components.destinations_field.select.page', { target })
        : I18n.t('components.destinations_field.select.all', { target })}
    </span>
  </button>
)

ButtonForAllSelect.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  isAllSelected: PropTypes.bool.isRequired,
  pagination: PropTypes.instanceOf(Pagination),
  target: PropTypes.string.isRequired,
  onChecked: PropTypes.func.isRequired
}

ButtonForAllSelect.defaultProps = {
  className: null,
  disabled: false,
  pagination: null
}

export default ButtonForAllSelect
